import authInstance from "./apiConfig";

export const userLogin = (data) => authInstance.post("/login", data)
